import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { Review } from '../models/review';

export class ReviewService extends BaseService<Review> {
  override model = Review;
  override modelName = 'review';
  override modelLabel = 'Review';

  async filter({
    page = 1,
    filters = {},
    limit = 20,
  }: {
    page?: number;
    filters?: Record<string, any>;
    limit?: number;
  } = {}): Promise<ApiListResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/list`,
      data: { ...filters },
      query: {
        page: page.toString(),
        limit: limit.toString(),
      },
    });

    return await this.requestList(request, Review);
  }

  async approve(
    review: Review,
  ): Promise<ApiResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${review.objectID()}/approve`,
    });

    return await this.requestItem(request, Review);
  }

  async unapprove(
    review: Review,
  ): Promise<ApiResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${review.objectID()}/unapprove`,
    });

    return await this.requestItem(request, Review);
  }

  async feature(
    review: Review,
  ): Promise<ApiResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${review.objectID()}/feature`,
    });

    return await this.requestItem(request, Review);
  }

  async unfeature(
    review: Review,
  ): Promise<ApiResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${review.objectID()}/unfeature`,
    });

    return await this.requestItem(request, Review);
  }

  async respond(
    review: Review,
    reply: string,
  ): Promise<ApiResponse<Review>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${review.objectID()}/reply`,
      data: { reply },
    });

    return await this.requestItem(request, Review);
  }
}
